import React from 'react';
import GoogleMapReact from 'google-map-react';

const Map = (props) => {
	const mapWidth = props.mapWidth ? `${props.mapWidth}%` : '50%';
	const mapHeight = props.mapHeight ? `${props.mapHeight}vh` : '50vh';

	const renderMarker = (map, maps) => {
		let place = props.place ? `<h4>${I18n.t('activerecord.attributes.event.place')}</h4><p>${props.place}</p>` : '';
		let city = props.city ? `<h4>${I18n.t('activerecord.attributes.event.city')}</h4><p>${props.city}</p>` : '';
		let infowindow = new google.maps.InfoWindow({
			content: `${city}${place}<a target='_blank' href='https://maps.google.com?q=${props.eventLat},${props.eventLng}'>${I18n.t('view_in_google_maps')}</a>`,
		});

		let marker = new maps.Marker({
			map: map,
			position: new maps.LatLng(parseFloat(props.eventLat), parseFloat(props.eventLng)),
			title: '',
		});
		marker.addListener('click', () => infowindow.open(map, marker));
	};

	return (
		<div style={{ height: mapHeight, width: mapWidth, margin: '10px auto', filter: props.showBlackAndWhiteMap ? 'grayscale(100%)' : 'none' }}>
			{props.eventLat && props.eventLng && (
				<GoogleMapReact
					bootstrapURLKeys={{ key: props.apiKey }}
					defaultCenter={{ lat: parseFloat(props.eventLat), lng: parseFloat(props.eventLng) }}
					defaultZoom={15}
					yesIWantToUseGoogleMapApiInternals={true}
					onGoogleApiLoaded={({ map, maps }) => renderMarker(map, maps)}></GoogleMapReact>
			)}
		</div>
	);
};

export default React.memo(Map);
